import React from 'react'
import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { mediaMinTablet, Truncate } from '@root/shared/ui-kit'

import type { PairModel } from '@root/entities/pair'

type PoolCardAddressProps = {
  pool: PairModel
}

export const PoolCardAddress: React.FC<PoolCardAddressProps> = ({ pool }) => {
  const { t } = useTranslation()
  return (
    <Root>
      <AddressItem>
        <AddressLabel>{t('pool.pair-ca')}:</AddressLabel>
        <AddressValue>
          <Truncate start={5} end={4}>
            {pool.address}
          </Truncate>
        </AddressValue>
      </AddressItem>
      <AddressItem
        css={css`
          grid-column: 3;
        `}
      >
        <AddressLabel>{t('pool.currency-ca')}:</AddressLabel>
        <AddressValue>
          <Truncate start={5} end={4}>
            {pool.quote.address}
          </Truncate>
        </AddressValue>
      </AddressItem>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  padding-block: 12px;

  // figma margins = 20px
  padding-inline: 16px;
  ${mediaMinTablet(css`
    padding-inline: 12px;
  `)}
`

const AddressItem = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 6px;
`

const AddressLabel = styled.span`
  color: var(--text-9);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  white-space: nowrap;
`

const AddressValue = styled.span`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
